/**
 * Codex connect route — eagerly registers the file route and its `beforeLoad`
 * auth gate; the page component and its atom/RPC imports are deferred to
 * `codex-connect.lazy.tsx` so they load only with this route, never in the
 * always-loaded `main` chunk (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { requireAuth } from "~/lib/server-auth.ts";

/**
 * Login gate for the route. Extracted so it can be unit-tested directly —
 * `requireAuth` throws a TanStack redirect when unauthenticated, so it must
 * run as a bare promise (never wrapped in Effect, which turns the redirect
 * into a FiberFailure).
 *
 * @since 1.0.0
 */
// oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await, not Effect
export const codexConnectBeforeLoad = async () => {
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await, not Effect
  const auth = await requireAuth();
  return { auth };
};

export const Route = createFileRoute("/codex-connect")({
  beforeLoad: codexConnectBeforeLoad,
});
